import React from 'react';

function ModernLoader({ isVisible = true, message = "Carregando produtos...", centered = true }) {
  if (!isVisible) return null;

  if (centered) {
    return (
      <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          zIndex: 9999
        }}
      >
        <div className="loading-spinner mb-3" style={{ width: '60px', height: '60px' }}></div>
        <h5 className="text-muted">{message}</h5>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <div className="loading-spinner mb-3"></div>
      <p className="text-muted mb-0">{message}</p>
    </div>
  );
}

// Skeleton loader para cards de produtos
export function ProductSkeleton({ count = 6 }) {
  return (
    <div className="products-grid">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="modern-card">
          {/* Skeleton da imagem */}
          <div 
            className="bg-light rounded"
            style={{ height: '200px' }}
            aria-hidden="true"
          >
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="spinner-border text-secondary" role="status">
                <span className="visually-hidden">Carregando...</span>
              </div>
            </div>
          </div>
          
          {/* Skeleton do conteúdo */}
          <div className="p-3">
            <div className="mb-2">
              <div className="bg-light rounded mb-1" style={{ height: '20px', width: '80%' }}></div>
              <div className="bg-light rounded" style={{ height: '16px', width: '60%' }}></div>
            </div>
            
            <div className="mb-3">
              <div className="bg-light rounded mb-1" style={{ height: '14px', width: '50%' }}></div>
              <div className="bg-light rounded mb-1" style={{ height: '14px', width: '40%' }}></div>
              <div className="bg-light rounded" style={{ height: '14px', width: '45%' }}></div>
            </div>
            
            <div className="mb-3">
              <div className="bg-light rounded" style={{ height: '40px' }}></div>
            </div>
            
            <div className="d-flex gap-2">
              <div className="bg-light rounded flex-fill" style={{ height: '38px' }}></div>
              <div className="bg-light rounded flex-fill" style={{ height: '38px' }}></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// Loading inline para ações
export function InlineLoader({ message = "Processando..." }) {
  return (
    <div className="d-flex align-items-center">
      <div className="spinner-border spinner-border-sm me-2" role="status">
        <span className="visually-hidden">Carregando...</span>
      </div>
      <span>{message}</span>
    </div>
  );
}

// Loading para página inteira
export function FullPageLoader({ message = "Carregando..." }) {
  return (
    <div 
      className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
      style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(10px)',
        zIndex: 9999 
      }}
    >
      <div className="loading-spinner mb-3" style={{ width: '60px', height: '60px' }}></div>
      <h5 className="text-muted">{message}</h5>
    </div>
  );
}

export default ModernLoader;
